import { type CduiModuleRegistry } from '@shipt/cdui-core/modules/registry'
import { moduleRegistry } from '@shipt/cdui-modules/registry'
import { SegwayCouponShelf, SegwayProductShelf } from '@/features/cdui/hostModules'

// The generated registry remains the source of schemas, resolvers, actions, and
// analytics metadata. Segway replaces only the two shelf renderers that need
// live host state after delivery has resolved their serializable data.
export const cduiModuleRegistry: CduiModuleRegistry = {
  ...moduleRegistry,
  'product-shelf': {
    ...moduleRegistry['product-shelf'],
    Component: SegwayProductShelf,
  },
  'coupon-shelf': {
    ...moduleRegistry['coupon-shelf'],
    Component: SegwayCouponShelf,
  },
}
